import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';

import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from "react-query";
import { router } from './common/router';

const queryClient = new QueryClient()
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <QueryClientProvider client={queryClient} contextSharing={true}>
      <RouterProvider router={router} /> 
    </QueryClientProvider>
    
  </React.StrictMode>
);
